export default __webpack_public_path__ + "static/media/editor-close-icon.bd658e7c.svg";